import { Star, StarHalf } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ProfessionalCardProps {
  id: string;
  name: string;
  specialty: string;
  rating: number;
  imageUrl: string;
}

export function ProfessionalCard({
  name,
  specialty,
  rating,
  imageUrl
}: ProfessionalCardProps) {
  const renderStars = (rating: number) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />);
    }

    if (hasHalfStar) {
      stars.push(<StarHalf key="half" className="w-4 h-4 fill-yellow-400 text-yellow-400" />);
    }

    const emptyStars = 5 - Math.ceil(rating);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<Star key={`empty-${i}`} className="w-4 h-4 text-gray-300" />);
    }

    return stars;
  };

  return (
    <div className="bg-card rounded-lg shadow-sm overflow-hidden transition-all duration-200 hover:shadow-md hover:-translate-y-1">
      <div className="h-40 relative overflow-hidden">
        <img
          src={imageUrl}
          alt={name}
          className="w-full h-full object-cover"
        />
      </div>
      
      <div className="p-4 text-center">
        <h3 className="font-semibold text-lg mb-1 text-card-foreground">
          {name}
        </h3>
        
        <p className="text-muted-foreground text-sm mb-2">
          {specialty}
        </p>
        
        <div className="flex justify-center items-center mb-3">
          <div className="flex">
            {renderStars(rating)}
          </div>
          <span className="text-xs text-muted-foreground ml-2">
            ({rating})
          </span>
        </div>
        
        <Button variant="outline" size="sm" className="w-full border-secondary text-secondary hover:bg-secondary/5">
          Ver Perfil
        </Button>
      </div>
    </div>
  );
}